import { render, staticRenderFns } from "./DeleteModalComponent.vue?vue&type=template&id=ed18e7a6"
import script from "./DeleteModalComponent.vue?vue&type=script&lang=js"
export * from "./DeleteModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports